import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.' + environment.brand + '.html',
    styleUrls: ['./header.component.' + environment.brand + '.scss'],
    providers: []
})
export class HeaderComponent {
    scrollToTop(): void {
        window.scroll(0, 0);
    }
}
